import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { media } from '../../../styles/style-utils';

import TextBlock from './TextBlock';
import { getArtworkUrl } from '../utils/Contentful';

export const getBackgroundImage = props => {
  const { imgSmallWebP, imgLargeWebP, imgSmall, imgLarge } = props;
  return imgSmallWebP || imgLargeWebP || imgLarge
    ? `image-set(
      ${imgSmall ? `url(${getArtworkUrl(imgSmall)}) 1x` : ''}
      ${imgSmallWebP ? `, url(${getArtworkUrl(imgSmallWebP)}) 1x` : ''}
      ${imgLargeWebP ? `, url(${getArtworkUrl(imgLargeWebP)}) 2x` : ''}
      ${imgLarge ? `, url(${getArtworkUrl(imgLarge)}) 2x` : ''}
    )`
    : `url(${getArtworkUrl(imgSmall)})`;
};

const Wrapper = styled.div`
  background-image: ${props =>
    props.imgMobile ? `url(${getArtworkUrl(props.imgMobile)})` : getBackgroundImage(props)};
  background-position: ${props => props.bgPosition || 50}%;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 0 auto;
  min-height: 550px;
  height: ${props => props.height};
  max-width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  ${media.large`
    background-image: ${props => getBackgroundImage(props)};
  `}

  ${media.large`
    flex-direction: row;
    align-items: center;
    height: ${props => props.height || '750px'};
  `};

  p {
    font-size: var(--fs-m);
  }

  .centerText {
    justify-content: center;
    align-items: center;
    display: flex;
    text-align: center;
    width: 100%;
    height: 100%;
    flex-direction: column;
    padding: 2rem;
  }

  .defaultText {
    padding-left: var(--default-horizontal-padding);
    padding-right: var(--default-horizontal-padding);
    justify-content: center;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    text-align: left;
    padding-top: ${props => props.paddingTop || '3rem'};
    padding-bottom: 2rem;

    ${media.large`
      max-width: 50%;
      margin-bottom: 0;
      flex-shrink: 1;
      padding-left: var(--padding-l);
      padding-top: 0;
    `};
  }
`;

const ContentWrapper = styled.div`
  background-image: ${props =>
    props.imgMobile ? `url(${getArtworkUrl(props.imgMobile)})` : getBackgroundImage(props)};
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  flex: 1 1 auto;
  min-height: 250px;

  ${media.large`
    background-image: ${props => getBackgroundImage(props)};
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 50%;
    height: 100%;
    flex: none;
    min-height: 0;
    background-size: cover;
  `};
`;

const Hero = ({ content, centerText, height }) => {
  return (
    <Wrapper
      imgSmallWebP={content.backgroundImageSmallWebP}
      imgLargeWebP={content.backgroundImageLargeWebP}
      imgSmall={content.backgroundImageSmall}
      imgLarge={content.backgroundImageLarge}
      imgMobile={content.bgImageMobile}
      height={height}
      bgPosition={content.backgroundPosition}
      paddingTop={content.paddingTop}
    >
      <TextBlock content={content} centerText={centerText} />
      {!centerText && content.artworkSmall && (
        <ContentWrapper
          imgSmallWebP={content.artworkSmallWebP}
          imgLargeWebP={content.artworkLargeWebP}
          imgSmall={content.artworkSmall}
          imgLarge={content.artworkLarge}
          imgMobile={content.artworkMobile}
        />
      )}
    </Wrapper>
  );
};

Hero.propTypes = {
  content: PropTypes.object,
  centerText: PropTypes.bool,
  height: PropTypes.string,
};

export default Hero;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/heroBlock/Hero.js